// Public company profile — GET /public/company
// (backend/src/routes/publicCompanyRoutes.js), no session required. Used by
// components/SiteHeader.jsx (brand name) and components/SiteFooter.jsx
// (address / phone / email / opening hours). The endpoint returns ONLY the
// five public-safe fields; there is nothing here to strip client-side.
//
// Rendered on every portal screen (both live inside PortalShell), so this is
// deliberately one shared, long-lived query — staleTime is generous because
// company details change rarely, and a stale footer for a few minutes after
// an admin edit is fine.

import { useQuery } from '@tanstack/react-query';
import apiClient from 'shared/api/client.js';

const EMPTY_COMPANY = { name: '', address: '', phone: '', email: '', openingHours: '' };

export function useCompanyInfo() {
  const query = useQuery({
    queryKey: ['public', 'company'],
    queryFn: () => apiClient.get('/public/company'),
    select: (data) => data.company,
    staleTime: 5 * 60 * 1000,
  });

  // Callers only ever want the object; a failed/pending fetch degrades to
  // empty strings, which every consumer already treats as "hide this line".
  return query.data || EMPTY_COMPANY;
}

export default useCompanyInfo;
